import React from "react"
import PropTypes from "prop-types"
import FormSectionAccordion from "../../../../../components/FormSectionAccordion"
import {Box} from "@mui/material"
import {observacaoFields} from "./constants"
import {renderGrid} from "../../../../../components/FieldRenderer"

const ObservacaoSection = ({
                               state,
                               setSectionField,
                               isValid,
                               showError,
                               actions,
                               defaultOpen = false,
                               syncToken = 0
                           }) => (
    <FormSectionAccordion
        title="Observação"
        isValid={isValid}
        showError={showError}
        actions={actions}
        defaultOpen={defaultOpen}
        syncToken={syncToken}
    >
        <Box sx={{mt: 1}}>
            {renderGrid(
                observacaoFields,
                state,
                (key) => (value) => setSectionField("observacao", key, value),
                {},
                {},
                (key, value) => setSectionField("observacao", key, value)
            )}
        </Box>
    </FormSectionAccordion>
)

ObservacaoSection.propTypes = {
    state: PropTypes.object.isRequired,
    setSectionField: PropTypes.func.isRequired,
    isValid: PropTypes.bool,
    showError: PropTypes.bool,
    actions: PropTypes.node,
    defaultOpen: PropTypes.bool,
    syncToken: PropTypes.number,
}

export default ObservacaoSection